import request from '@/utils/request'
// 营业额数据
// export const getTurnoverDataes = (data) =>
//   request({
//     'url': `/report/turnoverStatistics`,
//     'method': 'get',
//     data
//   })
// 首页数据
// // 今日数据
// export const getTodayDataes = () =>
//   request({
//     'url': `/workspace/todaydate`,
//     'method': 'get'
//   })
// 订单管理
  export const getOrderData = () =>
  request({
    'url': `/workspace/overviewRe`,
    'method': 'get'
  })
// 菜品总览
export const getOverviewDishes = () =>
request({
  'url': `/workspace/overviewPe`,
  'method': 'get'
})
// 套餐总览
export const getSetMealStatistics = () =>
request({
  'url': `/workspace/overviewZj`,
  'method': 'get'
})
// 营业数据
export const getBusinessData= () =>
request({
  'url': `/workspace/workData`,
  'method': 'get'
})
/**
 *
 * 报表数据
 *
 **/
// 统计
// 获取当日销售数据 -> 顶部数据
// export const getDataes = (params: any) =>
//   request({
//     'url': `/report/amountCollect/${params.date}`,
//     'method': 'get'
//   })




// 预约统计
export const getUserStatistics1= (params: any) =>
  request({
    'url': `/report/userStatistics`,
    'method': 'get',
    params
  })
  // 体检统计
export const getUserStatistics2= (params: any) =>
request({
  'url': `/report/peStatistics`,
  'method': 'get',
  params
})
// 健康证统计
export const getUserStatistics3= (params: any) =>
  request({
    'url': `/report/healthCertificatesStatistics`,
    'method': 'get',
    params
  })
  // 销量排名TOP10
  export const getTop= (params: any) =>
  request({
    'url': `/report/top10`,
    'method': 'get',
    params
  })
  // 数据概览
  export const getDataOverView= (params: any) =>
  request({
    'url': `/report/dataOverView`,
    'method': 'get',
    params
  })
  // 数据导出
  export function exportInfor(params:any) {
    return request({
      url: '/report/export',
      method: 'get',
      responseType: "blob",
      params
    })
  }

// 异常数据导出
export function errorExportInfor(params:any) {
  return request({
    url: '/report/exportError',
    method: 'get',
    responseType: "blob",
    params
  })
}

/**
 * 下载SQL文件
 * @param {Object} params - 可选参数：{ date: '2025-07-10' }
 * @returns {Promise} - 文件流Promise
 */
export function sqlExportInfor(params:any) {
  return request({
    url: '/report/sqlExport',
    method: 'get',
    responseType: "blob",
    params,
    transformResponse: [data => data] // 关键：不转换响应数据，直接返回blob
  })
}

/**
 * 下载送检文件
 * @param {Object} params - 可选参数：{ date: '2025-07-10' }
 * @returns {Promise} - 文件流Promise
 */
export function sjExportInfor(params:any) {
  return request({
    url: '/report/exportSj',
    method: 'get',
    responseType: "blob",
    params,
    transformResponse: [data => data] // 关键：不转换响应数据，直接返回blob
  })
}

/**
 * 健康证PDF导出（按日期范围合并打印）
 * @param {Object} params - { begin: 'yyyy-MM-dd HH:mm:ss', end: 'yyyy-MM-dd HH:mm:ss' }
 * @returns {Promise} - PDF文件流Promise
 */
export function healthCertExportInfor(params:any) {
  return request({
    url: '/healthCertExport',
    method: 'get',
    responseType: "blob",
    params,
    transformResponse: [data => data] // 关键：不转换响应数据，直接返回blob
  })
}

export function exportAllInfo(params:any) {
  return request({
    url: '/report/exportAll',
    method: 'get',
    responseType: "blob",
    params
  })
}

  //导出待上传数据
export function exportData() {
  return request({
    url: '/report/exportUploadData',
    method: 'get',
    responseType: "blob",
  })
}
